<template>
  <div class="pc">
    <div class="banner_content container">
      <p class="about-text d-none d-lg-block">
        在<span>视频原生</span>的世界
        <br />
        构建一种更好的连接方式
      </p>
      <p class="about-text d-lg-none">
        在<span>视频原生</span>的世界
        <br />
        构建一种更好的连接方式
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .pc {
    padding-bottom: 150px;
    overflow: hidden;
    background-image: url("https://zealcomm-site-assets.zealcomm.cn/about/banner-pc.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .banner_content {
      margin-top: 150px;

      .about-text {
        color: #333;
        font-size: 48px;
        font-weight: bold;
        text-align: center;

        span {
          color: $main-color;
        }
      }
    }
  }

  @media screen and (max-width: 992px) {
    .pc {
      padding-bottom: 50px;
      background-image: url("https://zealcomm-site-assets.zealcomm.cn/about/banner-mobile.png");

      .banner_content {
        margin-top: 50px;

        .about-text {
          font-size: 27px;
          text-align: left;
        }
      }
    }
  }
</style>
